import { render, staticRenderFns } from "./NiceButton.vue?vue&type=template&id=48307bd4&"
import script from "./NiceButton.vue?vue&type=script&lang=ts&"
export * from "./NiceButton.vue?vue&type=script&lang=ts&"
import style0 from "./NiceButton.vue?vue&type=style&index=0&id=48307bd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports